import { render, staticRenderFns } from "./systemInfo.vue?vue&type=template&id=47abd6b4&scoped=true&"
import script from "./systemInfo.vue?vue&type=script&lang=js&"
export * from "./systemInfo.vue?vue&type=script&lang=js&"
import style0 from "./systemInfo.vue?vue&type=style&index=0&id=47abd6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abd6b4",
  null
  
)

export default component.exports